export interface DataCreationDashboardResponse {
    accountsCreated: number;
    accountsUpdated: number;
    productsAdded: number;
}

export function createDataCreationDashboardResponse(): DataCreationDashboardResponse {
    return {
        accountsCreated: 0,
        accountsUpdated: 0,
        productsAdded: 0,
    };
}
